import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-senha-redefinida-sucesso',
  imports: [MatButtonModule, CommonModule],
  templateUrl: './senha-redefinida-sucesso.html',
  styleUrl: './senha-redefinida-sucesso.scss',
})
export class SenhaRedefinidaSucesso {}
